// extracted by mini-css-extract-plugin
export var leftAlign = "_39-2";
export var popper = "_39-0";
export var subtitle = "_39-1";